// Centralized language configuration
export const SUPPORTED_LANGUAGES = ['en', 'ro', 'fr'];
export const DEFAULT_LANGUAGE = 'en';

// Language display names (optional, for UI)
export const LANGUAGE_NAMES = {
  en: 'English',
  ro: 'Română',
  fr: 'Français'
};

// Language detection options
export const LANGUAGE_DETECTION_OPTIONS = {
  order: ['localStorage', 'navigator', 'htmlTag'],
  caches: ['localStorage'],
  checkWhitelist: true
};

// Helper function to get current language
export const getCurrentLanguage = (i18n) => {
  const currentLang = (i18n.resolvedLanguage || i18n.language || DEFAULT_LANGUAGE).toLowerCase();
  return SUPPORTED_LANGUAGES.find(lang => currentLang.startsWith(lang)) || DEFAULT_LANGUAGE;
};

// Helper function to check if language is Romanian
export const isRomanian = (i18n) => {
  return getCurrentLanguage(i18n) === 'ro';
};
